import { PromotionList } from './PromotionList'
import { withPromotionList } from './withPromotionList'

const ConnectedPromotionList = withPromotionList(PromotionList)

export { ConnectedPromotionList as PromotionList }
